import React, { useState } from "react";
import { useDispatch } from "react-redux";

import ModalGeneric from "./ModalGeneric";

import { addFlashMessage as addFlashMessageAction } from "../../actions/FlashMessagesAction";
import { getErrorMessageFromAxiosError } from "../../utils/axiosUtils";

export default function ModalGenericPostCancelContainer({
  id,
  apiCallData,
  modalTitle,
  submitButtonText,
  submittingButtonText,
  successPostCallFlashMessage,
  errorPostCallFlashMessage,
  className,
  submitButtonDisabled,
  showSubmitSpinner,
  openModalComponentFunction,
  handleApiCall,
  closeModal: closModalProp,
  handleCancel,
  children,
}) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [currentSubmitButtonText, setCurrentSubmitButtonText] =
    useState(submitButtonText);

  function closeModal() {
    setOpen(false);
    closModalProp && closModalProp();
  }

  function openModal() {
    setOpen(true);
  }

  async function saveAndClose() {
    setCurrentSubmitButtonText(submittingButtonText);
    const params = apiCallData ? [id, apiCallData] : [id];
    try {
      const shouldShowSuccess = await handleApiCall(...params);
      if (shouldShowSuccess === false) {
        setCurrentSubmitButtonText(submitButtonText);
        setOpen(false);
        return false;
      }
      setCurrentSubmitButtonText(submitButtonText);
      dispatch(
        addFlashMessageAction({
          type: "success",
          text: successPostCallFlashMessage,
        }),
      );
      setOpen(false);
      return true;
    } catch (error) {
      const isHandledError =
        error === "validationError" ||
        error === "Valideringsfeil" ||
        error === "popUpBlocked";

      if (!isHandledError && errorPostCallFlashMessage) {
        const errorMessage = getErrorMessageFromAxiosError(error);
        const text =
          typeof errorMessage === "string" && errorMessage.trim() !== ""
            ? `${errorPostCallFlashMessage} ${errorMessage}`
            : errorPostCallFlashMessage;

        dispatch(
          addFlashMessageAction({
            type: "error",
            text,
          }),
        );
      }
      setCurrentSubmitButtonText(submitButtonText);
      return false;
    }
  }

  return (
    <ModalGeneric
      modalTitle={modalTitle}
      open={open}
      closeModal={closeModal}
      openModal={openModal}
      OpenModalComponent={openModalComponentFunction}
      submit={saveAndClose}
      submitButtonText={currentSubmitButtonText}
      close={handleCancel}
      className={className}
      disabled={submitButtonDisabled}
      showSubmitSpinner={showSubmitSpinner}
    >
      {React.Children.map(children, (child) => child)}
    </ModalGeneric>
  );
}
